import axios from '@/api/config';

const formField = {
    pageList (data) {
        return axios.post(`${process.env.BASE_URL}/agentAmountLog/pageList`, data);
    },
    getAgentAmountStatsDTO (data) {
        return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentAmountStatsDTO`, { params: data });
    },

    queryListSumAmount (data) {
        return axios.post(`${process.env.BASE_URL}/agentAmountLog/queryListSumAmount`, data);
    },

    //    退单审批 待我审批

    queryApprover (data) {
        return axios.post(`${process.env.BASE_URL}/orderInfo/queryApprover`, data);
    },

    queryApproverV2 (data) {
        return axios.post(`${process.env.BASE_URL}/orderInfo/queryApprover_v2`, data);
    },
    //    退单审批 审批确认

    refundOrderAudit (data) {
        return axios.post(`${process.env.BASE_URL}/orderInfo/refundOrderAudit`, data);
    },
    //    退单审批 我已审批

    //    部分退单审批
    partRefundOrderAudit (data) {
        return axios.post(`${process.env.BASE_URL}/orderInfo/partRefundOrderAudit`, data);
    },

};

export default formField;



// WEBPACK FOOTER //
// ./src/api/agentAmountLog.js